export const DefaultOptions = {
  tabWidth: 2,
  useTabs: false
}

export default async function formatJSON(input, options={}) {
  const {tabWidth, useTabs} = {...DefaultOptions, ...options}

  const object = JSON.parse(input)
  if (useTabs) {
    return JSON.stringify(object, null, '\t')
  }
  return JSON.stringify(object, null, tabWidth)
}
